import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleHeading1 } from '@cian/ui-kit';
import { MortgageCalculatorSection as MortgageCalculatorSectionComponent } from '../../components/MortgageCalculatorSection';
import { MortgageCalculator } from '../MortgageCalculator';
import fskLogo from './assets/fsk-logo.png';
import { getFskCalculator } from '../../selectors/fsk/getFskCalculator';

export function MortgageCalculatorSection() {
  const config = useSelector(getFskCalculator);

  if (!config) {
    return null;
  }

  return (
    <MortgageCalculatorSectionComponent
      title={<ArticleHeading1>Ипотечный калькулятор</ArticleHeading1>}
      calculator={<MortgageCalculator config={config} logo={fskLogo} />}
    />
  );
}
